// Auto-detect API URL based on environment
const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const port = window.location.port;

    // React dev server (npm start): always use proxy path on same host (localhost, 127.0.0.1, or LAN IP).
    if (port === '3000' || port === '3001') {
      const fromEnv = process.env.REACT_APP_API_URL;
      if (fromEnv && fromEnv.startsWith('http')) {
        return fromEnv.replace(/\/$/, '');
      }
      return (fromEnv || '/api').replace(/\/$/, '') || '/api';
    }

    // Laravel-only (php artisan serve + built React on :8000)
    if ((hostname === 'localhost' || hostname === '127.0.0.1') && port === '8000') {
      return '/api';
    }

    // Production hostnames (including legacy typo domain)
    if (
      hostname === 'aliengreen.pharmagreen.co.tz' ||
      hostname === 'www.aliengreen.pharmagreen.co.tz' ||
      hostname === 'aliengreen.pharmagree.co.tz' ||
      hostname === 'www.aliengreen.pharmagree.co.tz'
    ) {
      return 'https://api.aliengreen.pharmagreen.co.tz/api';
    }
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  return 'http://127.0.0.1:8000/api';
};

const API_BASE_URL = getApiBaseUrl();

// Log for debugging (always log in production too for troubleshooting)
if (typeof window !== 'undefined') {
  console.log('[API Config] Detected hostname:', window.location.hostname);
  console.log('[API Config] Using API URL:', API_BASE_URL);
}

export default API_BASE_URL;
